// The drive's activity LED, as the page drives it: it lights while the files
// are in view, like a drive mounting, and goes dark when they leave. The
// amount eases (ease-out) to its target over GLOW_MS, from wherever it is when
// the target changes, so turning back halfway never jumps.
export const GLOW_ON = 0.5;
export const GLOW_MS = 500;

const easeOut = (t) => 1 - (1 - t) ** 3;

/** setGlow(amount): crossScene.setGlow. Times are in ms (performance.now()). */
export function createLed(setGlow) {
  let value = 0;
  let from = 0;
  let to = 0;
  let start = 0;
  return {
    /** Starts easing towards lit (GLOW_ON) or dark (0) at `now`. */
    set(lit, now) {
      const target = lit ? GLOW_ON : 0;
      if (target === to) return;
      from = value;
      to = target;
      start = now;
    },
    /** Call once a frame; calls setGlow only when the amount changes. */
    update(now) {
      if (value === to) return;
      const t = Math.min(1, Math.max(0, (now - start) / GLOW_MS));
      const next = t === 1 ? to : from + (to - from) * easeOut(t);
      if (next === value) return;
      value = next;
      setGlow(value);
    },
  };
}
